$('select[name="StudentId"]').on('change', function () {
    var activeAcyrText = $('ul.nav.flt_acyr li.active').text().trim();
    var activeWardteachingDataWard = $('ul.nav.flt_wardteaching li.active').attr('data-ward').trim();
    var selectedValue = $(this).val().trim();
    window.location = base_url + 'admin/reporting/student-events/' + activeAcyrText + '/' + activeWardteachingDataWard + '/' + selectedValue;
});
